import CollectionApi from 'client/api/v2/CollectionApi';
import axios from 'axios';

class GSuiteApi extends CollectionApi {
  constructor() {
    super('/api/v2/gsuites', {
      skip: 0,
      limit: 50,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      search: {
        fields: ['name'],
        searchTerm: '',
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  activate(name, directoryScopes = []) {
    return axios.post('/api/v2/gsuite/activate', { name, directoryScopes });
  }

  delete(id) {
    return this
      .initialize()
      .then(() => axios.delete(`${this.baseUrl}/${id}`, {}));
  }

  deleteDomain(id, domainId) {
    return axios.delete(`${this.baseUrl}/${id}/domains/${domainId}`, {});
  }

  getUserGroupsTotalCount(id) {
    return this.fetchTotalCount(`${this.baseUrl}/${id}/usergroups`);
  }

  reactivate(id, directoryScopes = []) {
    return this
      .initialize()
      .then(() => axios.post(`${this.baseUrl}/${id}/reactivate`, directoryScopes));
  }

  listDomains(id) {
    return axios.get(`${this.baseUrl}/${id}/import/domains`, {});
  }

  listSelectedDomains(id) {
    return axios.get(`${this.baseUrl}/${id}/domains`, {});
  }

  saveDomains(id, domain) {
    return axios.post(`${this.baseUrl}/${id}/domains`, domain);
  }
}

export default new GSuiteApi();
